import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.687342 11.966C-1.1704 7.59469 0.86721 2.54508 5.23847 0.687342C9.60974 -1.1704 14.6593 0.86721 16.5171 5.23847C18.3748 9.60974 16.3372 14.6593 11.966 16.5171C7.59469 18.3748 2.54509 16.3372 0.687342 11.966ZM5.81145 2.03555C2.18478 3.57685 0.494251 7.76631 2.03555 11.393C3.57685 15.0196 7.76631 16.7102 11.393 15.1689C15.0197 13.6276 16.7102 9.43812 15.1689 5.81145C13.6276 2.18478 9.43812 0.494251 5.81145 2.03555Z",
		fill: "currenColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.6471 13.6469C13.9331 13.3609 14.3969 13.3609 14.6829 13.647L20.7847 19.7497C21.0708 20.0357 21.0707 20.4995 20.7847 20.7855C20.4986 21.0715 20.0348 21.0715 19.7488 20.7854L13.647 14.6827C13.361 14.3967 13.361 13.9329 13.6471 13.6469Z",
		fill: "currenColor"
	})]
});
export { SvgSearch as ReactComponent };
